/* eslint-disable */
import React from "react";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import TextField from '@material-ui/core/TextField';
import { Row } from "react-flexbox-grid";
import Button from "components/CustomButtons/Button.jsx";

import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";

import httpr from "lib/httpRequest";
import { BASE_URL, AUTH_OPTIONS } from "lib/config";

import GetMemberInfo from "actions/MemberAction.jsx";
import NumberFormat from "react-number-format";
import ReactLoading from "react-loading";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import SnackbarContent from "components/Snackbar/SnackbarContent.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import Modal from "@material-ui/core/Modal";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  formControl: {
    margin: theme.spacing.unit,
    width: "99%",
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  dates: {
    display: "inline",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 28;
const PaperProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class ServiceRequest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      terminals: [],
      tabs: [],
      customTabsCompKey: 0,
      isAdmin: false,
      isService: false,
      deleteOpen: false,
      msg: "",
      memberIdToEdit: -1,
      loggedInMemberId: -1,
      selectedLocId: [],
      selectedTerminals: [],
      issue: "",
      email: "",
      phone: "",
      issueError: false,
      emailError: false,
      phoneError: false,
      snackbarMsg: "",
      snackbarOpen: false,
      snackbarIcon: AddAlertIcon,
      snackbarColor: "info",
      sendingRequest: false,
    };
    this.alertTimeout = null;
  }

  componentDidMount() {
    // fetch organization, location and member info
    this.getOrganizations();
    this.getMemberLocations();
    this.loadMemberInfo();
  }

  componentWillUnmount() {
    this.clearAlertTimeout();
  }

  getOrganizations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/organization`)
        .then((response) => {
          const organizations = response.data;
          const customTabsCompKey = organizations[0].OrganizationId;
          const loggedInMemberId = organizations[0].MemberId;
          const tabs = organizations.map((org) => {
            return {
              tabName: `${org.OrganizationName}`,
              dataUrl: `/api/location/organization/${org.OrganizationId}`,
              tabContent: <div />,
            };
          });

          this.setState({
            loggedInMemberId: loggedInMemberId,
            customTabsCompKey: customTabsCompKey,
            tabs: tabs,
          });

          if (loggedInMemberId !== null || loggedInMemberId !== undefined) {
            this.getMemberPrivileges(loggedInMemberId);

          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  // //TODO: fix route error
  // getTerminals(locationIds) {
  //   // fetch terminals for selected locations
  //   const { token } = this.props;
  //   const fetch = httpr(token);
  //   fetch
  //     .post("/api/terminal/locations/", { 
  //       locationIds: locationIds,
  //     })
  //     .then((response) => {
  //       const { terminals } = response.data;

  //       console.log("terminals: ", terminals);
  //       if (this._isMounted === true) {
  //         // set state
  //         this.setState({
  //           terminals: terminals,
  //           selectedTerminals: ["All"],
  //         });
  //       };
        
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // }

  getMemberPrivileges(memberId) {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/members/privileges/${memberId}`)
        .then((response) => {
          const isAdmin = response.data.Admin === 1 ? true : false;
          const isService = response.data.Service === 1 ? true : false;

          if (isAdmin || isService) {
            this.setState({
              isAdmin: isAdmin,
              isService: isService,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  getMemberLocations() {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    return new Promise(async (resolve, reject) => {
      fetch
        .get(`${BASE_URL}/api/location`)
        .then((response) => {
          this.setState({ locations: response.data });
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  loadMemberInfo() {
    const token = localStorage.getItem("token");
    if (token !== null && token !== undefined) {
      GetMemberInfo(token)
        .then((r) => {
          this.setState({ loading: false, ...r });
        })
        .catch((e) => {
          this.setState({ loading: false });
          console.log(e);
        });
    }
  };

  validateRequest = () => {
    if(this.state.selectedLocId === undefined || this.state.selectedLocId.length === 0){
      this.showError("Please select a location.");
    }
    else if(this.state.issue === undefined || this.state.issue === "" || !this.state.issue.replace(/\s/g, '').length){
      this.setState({ issueError: true });
      this.showError("Please describe the issue.");
    }
    else if(this.state.email === undefined || this.state.email === ""){
      this.setState({ emailError: true });
      this.showError("Email address is required");
    } 
    else if(!this.state.email.includes("@")){
      this.setState({ emailError: true });
      this.showError("Email address is not valid.");
    }
    else {
      return true;
    };
  };

  submitServiceRequest = () => {
    const memberId = this.state.loggedInMemberId;
    const location = this.state.locations.filter(location => location.LocationId == this.state.selectedLocId[0])[0];
    
    if(this.validateRequest() === true){
      this.setState({ sendingRequest: true });

      const request = {
        Member: this.state.member,
        Location: location,
        Terminals: this.state.selectedTerminals,
        Description: this.state.issue,
        Email: this.state.email,
        Phone: this.state.phone
      };
  
      const token = localStorage.getItem("token");
      const fetch = httpr(token);
  
      return new Promise(async (resolve, reject) => {
        fetch
          .post(`${BASE_URL}/api/serviceRequests/${memberId}`, { request })
          .then((response) => {
            if(response.data === "error"){
              this.showError("There was an error processing your request. Please call support to submit your request or try again later.");
            } else {
              this.showSuccess(response.data);
              this.setState({
                selectedLocId: [],
                issue: "",
                email: "",
                phone: "",
                sendingRequest: false,
              });
            }
          })
          .catch((error) => {
            this.showError("There was an error processing your request. Please call support to submit your request or try again later.")
          })
      });
    }
  };

  showSuccess = (msg) => {
    this.setState({
      snackbarOpen: true,
      snackbarMsg: msg,
      snackbarIcon: AddAlertIcon,
      snackbarColor: "info"
    });
  };
  showError = (msg) => {
    this.setState({
      snackbarOpen: true,
      snackbarMsg: msg,
      snackbarIcon: ErrorOutlineIcon,
      snackbarColor: "danger"
    });
  }

  handleChangedLocation = (event) => {
    this.setState({ selectedLocId: event.target.value });
  };

  handleDeleteClose = () => {
    this.setState({ deleteOpen: false });
  };



  clearAlertTimeout = () => {
    if (this.alertTimeout !== null) {
      clearTimeout(this.alertTimeout);
    }
  };

  showNotification = (msg) => {
    this.setState({
      tc: true,
      addOpen: false,
      editOpen: false,
      deleteOpen: false,
      msg,
    });
  };

  handleClickOpen = () => {
    this.setState({ addOpen: true });
  };

  handleClose = () => {
    this.setState({ addOpen: false });
  };

  handleEditClickOpen = () => {
    this.setState({ editOpen: true });
  };

  handleEditClose = () => {
    this.setState({ editOpen: false });
  };

  handleChangeIssue = (event) => {
    this.setState({ issue: event.target.value, issueError: false });
  };

  onPhoneInputChange = (val) => (event) => {
    this.setState({ phone: event.target.value });
  };

  onEmailInputChange = (val) => (event) => {
    this.setState({ email: event.target.value, emailError: false });
  };

  renderSelectedLocationValues = (event) => {
    const locationId = event[0];
    let selectedLocationName = this.state.locations.map(loc => {
      if (loc.LocationId == locationId) {
        return loc.LocationName;
      }
    });
    return selectedLocationName;
  };

  render() {
    const { classes } = this.props;
    const { locations } = this.state;

    let allLocations = locations.map((loc) => (
      <MenuItem key={loc.LocationId} value={[loc.LocationId]}>
        {loc.LocationName.replace(/_/g, " ")}
      </MenuItem>
    ));

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
          <Snackbar
            place="tc"
            color={this.state.snackbarColor}
            icon={this.state.snackbarIcon}
            message={this.state.snackbarMsg}
            open={this.state.snackbarOpen}
            closeNotification={() => this.setState({ snackbarOpen: false })}
          />
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>Submit Machine Service Request</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <FormControl className={classes.formControl}>
                  <InputLabel htmlFor="select-location">
                    Select Location
                  </InputLabel>
                  <Select
                    name="selectedLocIds"
                    value={this.state.selectedLocId}
                    onChange={this.handleChangedLocation}
                    input={<Input id="select-multiple-checkbox" />}
                    renderValue={this.renderSelectedLocationValues}
                    MenuProps={PaperProps}
                  >
                    {allLocations}
                  </Select>
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <FormControl className={classes.formControl}>
                  <TextField
                    id="issue-description"
                    label="Please explain the issue."
                    multiline
                    rows={4}
                    rowsMax={10}
                    value={this.state.issue}
                    onChange={this.handleChangeIssue}
                    variant="outlined"
                    fullWidth={true}
                    error={this.state.issueError}
                  />
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={12} md={6}>
                <FormControl className={classes.formControl}>
                  <CustomInput
                      labelText="Email Address (Required)"
                      id="email"
                      name="email"
                      value={this.state.email}
                      error={this.state.emailError}
                      onChange={this.onEmailInputChange("email")}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                </FormControl>
              </GridItem>

              <GridItem xs={12} sm={12} md={6}>
                <FormControl className={classes.formControl}>
                  <NumberFormat
                    floatingLabelText="+1 555-555-5555"
                    customInput={CustomInput}
                    format="+1 ###-###-####"
                    mask="_"
                    id="Phone"
                    type="tel"
                    value={this.state.phone}
                    onChange={this.onPhoneInputChange("Phone")}
                    labelText="+1 555-555-5555 (Optional)"
                    name="Phone"
                    error={this.state.phoneError}
                    formControlProps={{
                      fullWidth: true,
                    }}
                  />
                </FormControl>
              </GridItem>

              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button
                color="success"
                onClick={this.submitServiceRequest}
              >
                {this.state.sendingRequest ? (
                  <ReactLoading
                  type="spin"
                  color="#000000"
                  style={{
                    width: "20%",
                    margin: "auto",
                  }}
                />
                ) : (
                  "Submit"
                )}
              </Button>
            </CardFooter>
          </Card>

        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(ServiceRequest);



// WEBPACK FOOTER //
// ./src/views/ServiceRequest/ServiceRequest.jsx